document.addEventListener('DOMContentLoaded', function() {

    const pdp = {
        activeVariantId: null,
        quantityObject: null,
        quantityElement: null,
        defaultMaxQuantity: null,
        cartButton: null,
        checkoutButton: null,
        cartDrawerItems: [],
        cartPageItems: [],
    }

    const we_events = {
        pubSubEvents: {
            openCartDrawer: "openCartDrawer",
            cartUpdate: "cartUpdate",
        },
        events: {},
        subscribe: function(event, callback) {
            if (!this.events[event]) {
                this.events[event] = [];
            }
            this.events[event].push(callback);
        },
        emit: function(event, data) {
            if (this.events[event]) {
                this.events[event].forEach((cb) => cb(data));
            }
        }
    };

    const locations = {
        b2b: "84495925521",
        b2c: "84141048081"
    }

    let productsMap = {}

    async function main() {
        initGlobalObject();
        await fillProductsMap();
        await setupPdp();
        subscribeEvents();
        manageCartButton();
        setCartDrawerProductsMaxQuantity();
        updateCartPageItems();
        setCartPageProductsMaxQuantity();
    }

    function initGlobalObject() {
        window.we_b2b = {
            we_events: we_events,
        }
    }

    async function setupPdp() {

        const wesiteObj = window.wesite;
        if (!wesiteObj) return;

        pdp.activeVariantId = wesiteObj.product.variantId.toString();
        setPdpQuantityObject();

        const quantityElement = document.querySelector("quantity-input.quantity");
        if (!quantityElement) return;
        pdp.quantityElement = quantityElement;

        const cartButton = document.querySelector(".product-form__submit");
        if (!cartButton) return;
        pdp.cartButton = cartButton;

        const checkoutButton = document.querySelector(".shopify-payment-button");
        if (checkoutButton) pdp.checkoutButton = checkoutButton;

        await setPDPDefaultMaxQuantity();
        setMaxQuantityPDP();
    }

    async function setPDPDefaultMaxQuantity() {
        if (!pdp.activeVariantId) return;
        const locationId = window.customerTags &&
            lowerCaseArray(window.customerTags).includes("b2b")
            ? locations.b2b
            : locations.b2c;

        const inventoryData = await getInventoryData(locationId, window.wesite.product.productId, pdp.activeVariantId);
        pdp.defaultMaxQuantity = inventoryData.data.inventory_levels[0].available;
    }

    function setPdpQuantityObject() {
        if (!pdp.activeVariantId) return;
        pdp.quantityObject = productsMap[pdp.activeVariantId] || null;
    }

    function setMaxQuantityPDP() {
    if (!pdp.activeVariantId) return;

    if (!productsMap[pdp.activeVariantId]) {
        pdp.quantityObject = {
            maxQuantity: pdp.defaultMaxQuantity,
            quantity: 0
        }
    }

    const inputElement = pdp.quantityElement.querySelector("input");
    if (!inputElement) return;

    const rest = pdp.quantityObject.maxQuantity - pdp.quantityObject.quantity;
    const value = parseInt(inputElement.value);
    inputElement.setAttribute("max", rest);

    const plusButton = document.querySelector(".price-per-item__container quantity-input .quantity__button[name='plus']");    

    // if (plusButton) {
    //     if (value >= rest) {
    //         plusButton.classList.add("disabled");
    //         inputElement.value = rest === 0 ? 1 : rest;
    //         return;
    //     } else {
    //         plusButton.classList.remove("disabled");  
    //     }
    // } else {
    //     console.warn("plusButton not found in", pdp.quantityElement);
    // }
}




    async function fillProductsMap() {
        try {
            productsMap = {};
            const products = await getCartProducts();
            const locationId =
                window.customerTags &&
                lowerCaseArray(window.customerTags).includes("b2b")
                    ? locations.b2b
                    : locations.b2c;

            const promises = [];
            for (const product of products.items) {
                promises.push(
                    getInventoryData(locationId, product.product_id, product.variant_id)
                );
            }

            const locationData = await Promise.all(promises);

            locationData.forEach((data, index) => {
                const variantId = products.items[index].variant_id;
                productsMap[variantId] = {
                    maxQuantity: data.data.inventory_levels[0].available,
                    quantity: products.items[index].quantity
                }
            });

        } catch (error) {
            console.error("ERROR", error);
        }

    }

    async function getCartProducts() {
        try {
            const response = await fetch("/cart.json");
            return await response.json();
        } catch (error) {
            throw new Error("Error getting cart products");
        }
    }

    async function getInventoryData(locationId, productId, variantId) {
        const response = await fetch(
            `https://getinventorylevel-kfot6cmmna-uc.a.run.app`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    locationId: String(locationId),
                    productId: String(productId),
                    variantId: String(variantId),
                }),
            }
        );
        return response.json();
    }

    function lowerCaseArray(array) {
        return array.map((item) => item.toLowerCase());
    }

    function subscribeEvents() {
        openCartDrawerEvent();
        updateCartDrawerEvent();
    }

    function openCartDrawerEvent() {
        we_events.subscribe(
            we_events.pubSubEvents.openCartDrawer,
            async () => {
                updateCartDrawerItems();
                updateCartPageItems();
                await fillProductsMap();
                setCartDrawerProductsMaxQuantity();
                setCartPageProductsMaxQuantity();
                setPdpQuantityObject();
                setMaxQuantityPDP();
                manageCartButton();
            }
        );
    }

    function updateCartDrawerItems() {
        const cartDrawerItems = document.querySelectorAll(".m-cart-item[we-variant-id]") || [];
        pdp.cartDrawerItems = Array.from(cartDrawerItems);
    }

    function updateCartDrawerEvent() {
        we_events.subscribe(
            we_events.pubSubEvents.cartUpdate,
            async () => {
                updateCartDrawerItems();
                updateCartPageItems();
                await fillProductsMap();
                setCartDrawerProductsMaxQuantity();
                setCartPageProductsMaxQuantity();
                setPdpQuantityObject();
                setMaxQuantityPDP();
                manageCartButton();
            }
        );
    }

    function updateCartPageItems() {
        const cartPageItems = document.querySelectorAll(".m-cart-item[we-variant-id]") || [];
        pdp.cartPageItems = Array.from(cartPageItems);
    }

    function setCartDrawerProductsMaxQuantity() {
        if (pdp.cartDrawerItems.length === 0) return;

        pdp.cartDrawerItems.forEach((item) => {
            const variantId = item.getAttribute("we-variant-id");
            const maxQuantity = productsMap[variantId].maxQuantity;

            const inputElement = item.querySelector("input[type='number']");
            const plusButton = item.querySelector(".m-quantity__button[name='plus']");

            inputElement.setAttribute("max", maxQuantity);

            const rest = maxQuantity - parseInt(inputElement.value);

            if (rest <= 0) {
                plusButton.classList.add("m-disabled");
            } else {
                plusButton.classList.remove("m-disabled");
            }
        });
    }

    function setCartPageProductsMaxQuantity() {
        if (pdp.cartPageItems.length === 0) return;

        pdp.cartPageItems.forEach((item) => {
            const variantId = item.getAttribute("we-variant-id");
            const maxQuantity = productsMap[variantId].maxQuantity;

            const inputElement = item.querySelector("input[type='number']");
            const plusButton = item.querySelector(".quantity__button[name='plus']");

            inputElement.setAttribute("max", maxQuantity);

            const rest = maxQuantity - parseInt(inputElement.value);

            if (rest <= 0) {
                plusButton.classList.add("m-disabled");
            } else {
                plusButton.classList.remove("m-disabled");
            }
        });
    }

    function manageCartButton() {
        if (!pdp.activeVariantId) return;
        if (!pdp.quantityObject) return;

        if (pdp.quantityObject.quantity >= pdp.quantityObject.maxQuantity) {
            disableCartButton();
        } else {
            enableCartButton();
        }
    }

    function disableCartButton() {
        if (!pdp.cartButton) return;

        if (pdp.checkoutButton) {
            pdp.checkoutButton.classList.add("we-hide");
        }
        pdp.cartButton.classList.add("we-custom-disabled");
    }

    function enableCartButton() {
        if (!pdp.cartButton) return;

        pdp.cartButton.classList.remove("we-custom-disabled");

        if (pdp.checkoutButton) {
            pdp.checkoutButton.classList.remove("we-hide");
        }
    }

    main();
});
